import React from "react";
import { Navigate } from "react-router-dom";

import type { ReactElement } from "react";

interface ProtectedRouteProps {
  element: ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const token = localStorage.getItem("token");

  // If token does not exist, redirect to login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // If token exists, render the element
  return element;
};

export default ProtectedRoute;
